import React, { Component } from "react";
import { connect } from "react-redux";
import { api } from "../../_services";
import { modalAlert } from "../../_actions";
import { Row, Col, FormGroup, FormControl, ControlLabel, HelpBlock, Button } from "react-bootstrap";
import MenuBar from "../MenuBar";
import ResolutionCategoryDropdown from "../ResolutionCategoryDropdown";
import FilterMenuBar from "../FilterMenuBar";
import FontAwesome from "react-fontawesome";
import { Redirect } from "react-router";
import { Link } from "react-router-dom";
import "../NoteActionPageCommon/index.css";
import "./index.css";

class NoteResolvePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validated: false,
      waitingForResponse: false,
      resolution: "",
      resolutionCategory: "",
      resolutionDescriptionCheck: false,
      note: null,
      redirect: null
    };
  }

  componentDidMount = () => {
    if (this.props.match.params !== null && this.props.configList) {
      const noteID = this.props.match.params.noteID;
      this.getNote(noteID);
    }
  };

  componentWillReceiveProps = nextProps => {
    if (JSON.stringify(this.props.configList) !== JSON.stringify(nextProps.configList)) {
      if (this.props.match.params !== null) {
        const noteID = this.props.match.params.noteID;
        this.getNote(noteID);
      }
    }
  };

  getNote = id => {
    const url = `/api/v1/notes/${id}/`;
    const errorMsg = "Unable to get the current note details.";
    api.getFetch(url, "", this.props.user.token, errorMsg).then(json => {
      this.setState(() => {
        return { note: json };
      });
    });
  };

  onChange = e => {
    const state = this.state;
    state[e.target.name] = e.target.value;
    this.setState(() => {
      return { state };
    });
  };

  setResolutionCategory = val => {
    this.setState(() => {
      return {
        resolutionCategory: val ? val.id : null,
        resolutionDescriptionCheck: val ? val.requires_description : false
      };
    });
  };

  submitForm = () => {
    const { resolutionCategory, resolution, resolutionDescriptionCheck } = this.state;

    this.setState(() => {
      return { validated: true };
    });

    if (!resolutionCategory) {
      return;
    }

    if (resolutionDescriptionCheck) {
      if (resolution !== null && resolution.length > 0) {
        this.submitResolution();
      }
    } else {
      this.submitResolution();
    }
  };

  submitResolution = () => {
    const { note, resolutionCategory, resolution, resolutionDescriptionCheck } = this.state;

    const url = `/api/v1/notes/${note.id}/resolve/`;
    const errorMsg = "Unable to resolve this note.";
    let payload = {};

    this.setState(() => {
      return { waitingForResponse: true };
    });

    if (resolutionDescriptionCheck) {
      payload = {
        resolution_description: resolution,
        resolution_category: resolutionCategory
      };
    } else {
      if (resolution) {
        payload = {
          resolution_description: resolution,
          resolution_category: resolutionCategory
        };
      } else {
        payload = {
          resolution_category: resolutionCategory
        };
      }
    }

    api.postFetch(url, payload, this.props.user.token, errorMsg, true).then(json => {
      this.setState(() => {
        return { waitingForResponse: false };
      });

      if (json.success) {
        this.setState({ redirect: `/note/${note.id}/view` });
      }
    });
  };

  renderTitlePanel = () => {
    const { note } = this.state;

    return (
      <div>
        <div className="mainTitle">
          <div className="breadCrumb">
            <Link to={`/note/${note.id}/view`}>
              <FontAwesome name="arrow-left" size="lg" /> Back to Note
            </Link>
          </div>
          <h1>Resolve Note: {`${note.title} (ID: ${note.id})`}</h1>
        </div>
      </div>
    );
  };

  renderLoadingPage = () => {
    return (
      <div>
        <MenuBar />
        <FilterMenuBar />
        <div className="map-container">
          <div className="loading" />
        </div>
      </div>
    );
  };

  renderFormButtons = () => {
    const { waitingForResponse, note } = this.state;

    if (waitingForResponse) {
      return <div className="submitted-message">Resolving note...</div>;
    } else {
      return (
        <div className="form-action-buttons">
          <Link to={`/note/${note.id}/view`} className="btn btn-default">
            Cancel
          </Link>
          <Button bsStyle="primary" onClick={this.submitForm}>
            Resolve Note
          </Button>
        </div>
      );
    }
  };

  renderWorkflow = () => {
    return (
      <div className="workflow-track">
        <div className="workflow-track-state workflow-track-state-active">Open</div>
        <div className="workflow-track-state-transition">
          <span className="workflow-transition-direction-left">↓</span>
          Resolve
          <span className="workflow-transition-direction-right">↓</span>
        </div>
        <div className="workflow-track-state">Resolved</div>
        <div className="workflow-track-state">Signed Off</div>
      </div>
    );
  };

  renderResolutionCategoryDropdown = () => {
    const { validated, resolutionCategory } = this.state;

    return (
      <FormGroup validationState={validated && !resolutionCategory ? "error" : null}>
        <ResolutionCategoryDropdown change={this.setResolutionCategory} />
        {validated && !resolutionCategory ? (
          <div className="errorMsgCon">
            <HelpBlock>
              <FontAwesome name="exclamation-circle" /> Please select a resolution category.
            </HelpBlock>
          </div>
        ) : null}
      </FormGroup>
    );
  };

  renderResolutionDescriptionTextBox = () => {
    const { validated, resolutionDescriptionCheck, resolution } = this.state;

    return (
      <FormGroup validationState={resolutionDescriptionCheck ? (validated && !resolution ? "error" : null) : null}>
        <ControlLabel>
          Resolution Description
          {resolutionDescriptionCheck ? "*" : null}
        </ControlLabel>
        <FormControl
          componentClass="textarea"
          placeholder="Describe the resolution achieved for this note"
          name="resolution"
          value={resolution}
          onChange={this.onChange}
        />
        {resolutionDescriptionCheck ? (
          validated && !resolution ? (
            <div className="errorMsgCon">
              <HelpBlock>
                <FontAwesome name="exclamation-circle" /> Please enter a resolution.
              </HelpBlock>
            </div>
          ) : null
        ) : null}
      </FormGroup>
    );
  };

  renderForm = () => {
    return (
      <form>
        {this.renderResolutionCategoryDropdown()}
        {this.renderResolutionDescriptionTextBox()}
        {this.renderFormButtons()}
      </form>
    );
  };

  renderMessage = () => {
    return (
      <p>
        You are about to mark this note as resolved. To do so, please use the text box below to describe why you
        consider this note to be resolved, then click "Resolve".
      </p>
    );
  };

  renderMainContent = () => {
    if (!this.state.note.can_be_resolved) {
      return (
        <div className="panel-div">
          <p>This note cannot be resolved at this time.</p>
        </div>
      );
    }
    return (
      <Row>
        <Col md={3} xs={12} className="hidden-sm hidden-xs">
          {this.renderWorkflow()}
        </Col>
        <Col md={9} xs={12}>
          <div className="panel-div">{this.renderMessage()}</div>
          <div className="panel-div">{this.renderForm()}</div>
        </Col>
      </Row>
    );
  };

  render = () => {
    if (this.state.redirect) {
      return <Redirect push to={this.state.redirect} />;
    }

    if (this.state.note === null) {
      return <div>{this.renderLoadingPage()}</div>;
    }

    return (
      <div className="viewNotePage">
        <MenuBar />
        <FilterMenuBar />
        <div className="mainPanelCon">
          <div className="container">
            {this.renderTitlePanel()}

            <div className="mainContent">{this.renderMainContent()}</div>
          </div>
        </div>
      </div>
    );
  };
}

function mapStateToProps(state) {
  const { configList } = state.configuration;
  const { user } = state.authentication;
  return {
    user,
    configList
  };
}

export default connect(
  mapStateToProps,
  {
    modalAlert
  }
)(NoteResolvePage);



// WEBPACK FOOTER //
// ./src/_components/NoteResolvePage/index.js